
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: {
    value: { type: Boolean, default: false }
  },
  emits: ['switcherToggled'],
  setup(props) {
    const icon = computed(() => {
      return `toggle-${props.value ? 'on' : 'off'}-large`
    })

    return { icon }
  }
})
